import React, { useState, useEffect } from 'react';
import { connect, useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import _ from 'lodash';

import {
  Content,
  Dialog,
  Heading,
  Switch,
} from '@adobe/react-spectrum';

// I18n
import { I18n, Translate } from 'react-redux-i18n';

// Redux Actions
import { addSingleFilter, removeSingleFilter } from '../../actions/filterActions';

// Analytics
import Analytics from './Analytics';

// Styles
import '../../styles/FilterCommon.scss';
import '../../styles/SpecializedToggleFilter.scss';
import { withRouter } from '../withRouter';

const SpecializedToggleFilter = ({ router, appliedFilters }) => {
  const dispatch = useDispatch();

  // Handle toggling the specialized filter
  const handleSpecializedToggler = (e) => {
    if (e) {
      dispatch(addSingleFilter({ name: 'specialized', value: true }, router));

      // Capture analytics event
      Analytics.setEvent('FilterApplied', 'filterInteraction');

      const analyticsKeys = [
        { path: 'search.primaryFilter.filterInfo', value: { keyword: 'Applied', category: 'specialized' } },
        { path: 'search.filter', value: Analytics.getSetFiltersFromState(appliedFilters) },
      ];

      Analytics.setMultipleProps(analyticsKeys);
      Analytics.track('event');
      Analytics.clearMultipleProps(analyticsKeys);
      Analytics.clearEvent();
    } else {
      dispatch(removeSingleFilter({ name: 'specialized' }, router));
    }
  };
  const selected = _.has(appliedFilters, 'specialized');

  // JSX for the dialog on desktop
  const renderSpecializedToggleFilter = () => (
    <Dialog UNSAFE_className="specialized-dialog">
      <div className="specialized-top-section">
        <div className="specialized-switch-section">
          <Switch
            aria-label={I18n.t('partner_finder.filters.specialized_label')}
            isEmphasized
            UNSAFE_className="specialized-toggle-switch"
            isSelected={selected}
            onChange={handleSpecializedToggler}
          />
        </div>
        <Heading UNSAFE_className="specialized-dropdown-title">
          <Translate value="partner_finder.filters.specialized_header" />
        </Heading>
      </div>
      <Content UNSAFE_className="specialized-dropdown-content">
        {'Learn more about '}
        <a href={window.directoryConfig.specializationLink} target="_blank" rel="noreferrer">Specializations</a>
        .
      </Content>
    </Dialog>
  );

  return (
    <div className="cmp-specializedToggleFilter" id="specialized-filter">
      {renderSpecializedToggleFilter()}
    </div>
  );
};

SpecializedToggleFilter.propTypes = {
  router: PropTypes.shape({}).isRequired,
  appliedFilters: PropTypes.shape({
    specialized: PropTypes.bool,
  }),
};

SpecializedToggleFilter.defaultProps = {
  appliedFilters: {},
};

const mapStateToProps = (state) => ({
  locale: state.i18n.locale,
  appliedFilters: state.filter.selected,
});

const mapDispatchToProps = {
  addSingleFilterAction: addSingleFilter,
  removeSingleFilterAction: removeSingleFilter,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(SpecializedToggleFilter));
